export const info = {
  usage: {
    noRecords: 'No hay recursos disponibles',
    deleteMsg: '¿Está seguro que quiere eliminar este uso del inventario de transacciones?',
  },
};
